<template>
  <div>
    <div>
      <div class="row pt-3 l-m-b-20">
        <div class="col-8">
          <h1>Messages</h1>
        </div>
      </div>
    </div>
    <template v-if="!messages">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover">
        <thead class="m-table__heading">
          <tr>
            <th />
            <th class="m-table__id">Date</th>
            <th>Message</th>
            <th>Lead</th>
            <th>User</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="message in messages" :key="message.id"
              @click="$_can('leads.follow-ups.index') && chatHistory(message.lead_id, message.lead_follow_up_id)" class="pointer"
          >
            <td class="text-center">
              <div :class="message.new && 'dot-blue'" />
            </td>
            <td>{{ message.date }}</td>
            <td class="py-2 text-wrap">{{ message.body }}</td>
            <td>
              <router-link :to="{ name: 'LeadsEdit', params: { id: message.lead_id }}">
                {{ message.lead_ref_id }}
              </router-link>
            </td>
            <td>{{ message.cluster_user_name }}</td>
            <td>{{ message.company_name }}</td>
          </tr>
          <tr v-if="messages && !messages.length">
            <td colspan="8" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row blocks">
        <div class="col-md-6 mb-1 text-black-50 d-none d-md-block"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-md-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <modal v-if="showModal" @close="closeModal" :size="'modal-large'">
      <div slot="header">
        <h4>Chat history</h4>
      </div>
      <div slot="body">
        <div class="container">
          <div class="row mb-4">
            <div class="col">
              <div class="select-wrap">
                <label>Send to</label>
                <p class="form-control">
                  {{ thread.meta.receiver.phone ? phoneMask.maskedPhone(thread.meta.receiver.phone) : 'No phone added' }}
                </p>
              </div>
            </div>
          </div>
          <div class="row mb-4 scrollable">
            <div class="col-12" v-for="message in thread.data" :key="message.id">
              <template v-if="message.direction === 2">
                <div class="row">
                  <div class="col-9 bg-primary rounded">
                    <p class="m-1 text-white">{{ message.body }}</p>
                    <p v-for="media in message.media" :key="media.id" class="w-25 text-media pointer" @click="openFile(media.url)">
                      <img :src="media.url" class="img img-fluid" alt="" />
                    </p>
                  </div>
                  <div class="col-3" />
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
              <template v-else class="m-1">
                <div class="row">
                  <div class="col-3" />
                  <div class="col-9 bg-light rounded">
                    <p class="m-1">{{ message.body }}</p>
                    <p v-for="media in message.media" :key="media.id" class="w-25 text-media pointer" @click="openFile(media.url)">
                      <img :src="media.url" class="img img-fluid" alt="" />
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col text-right">
                    <small class="m-1">{{ message.date }}</small>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-10 pr-0">
              <div class="select-wrap h-auto">
                <label>{{ thread.meta.sender.company_name }} {{ thread.meta.sender.phone }}:</label>
                <div contenteditable="true">
                  <textarea class="form-control"
                            v-model="newMessage"
                            @keypress.enter.prevent="send"
                            :disabled="sending"
                  />
                </div>
              </div>
            </div>
            <div class="col-2 pl-0">
              <button type="button"
                      class="pt-2 w-100 btn btn-primary ld-ext-right"
                      :class="sending ? 'running' : ''"
                      @click="send"
                      :disabled="!newMessage || sending"
                      v-if="$_can('leads.follow-ups.store')"
              >
                <span class="mod-icon-note" />
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12" />
        </div>
        <div class="clearfix" />
      </div>
    </modal>
  </div>
</template>

<script>
import store from 'store';
import axios from 'axios';
import moment from 'moment/moment';
import { mapState } from 'vuex';
import toastr from 'toastr';
import Modal from '../Modal';
import Pagination from '../Pagination';
import Errors from '../../classes/Errors';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'Messages',
  components: {
    Pagination,
    Modal,
  },
  data: () => ({
    q: '',
    page: 1,
    company: '',
    companyId: store.get('dispatchUser').company_id,
    messages: null,
    thread: {
      data: {
        body: null,
      },
      meta: null,
    },
    newMessage: '',
    showModal: false,
    sending: false,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
  },
  mounted() {
    this.getAllMessages();
  },
  methods: {
    changePage(pageNum) {
      this.page = pageNum;
      this.getAllMessages();
    },
    chatHistory(leadId, leadFollowUpId) {
      axios
        .get(`leads/${leadId}/follow-ups/${leadFollowUpId}`)
        .then(res => {
          this.getAllMessages();
          this.thread = res.data;
          this.showModal = true;
          this.$nextTick(() => {
            const el = document.querySelector('.scrollable');
            el.scrollTop = el.scrollHeight;
          });
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    clearFilters() {
      this.company = '';
      this.filter();
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    closeModal() {
      this.showModal = false;
      this.getAllMessages();
      this.message = {};
    },
    getAllMessages() {
      axios
        .get(`leads/follow-ups?page=${this.page}`)
        .then(res => {
          this.messages = res.data.data;
          this.meta = res.data.meta;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    openFile(url) {
      window.open(url, '_blank');
    },
    send() {
      if (!this.newMessage.trim()) {
        return;
      }
      this.sending = true;
      const newMessageObject = {
        from: this.thread.meta.sender.phone,
        to: this.thread.meta.receiver.phone,
        type_id: 4,
        type: 4,
        notes: '',
        body: this.newMessage.trim(),
        date: moment().format('l LT'),
        direction: 2,
        sender: this.thread.meta.sender,
      };
      axios
        .post(`leads/${this.thread.meta.lead_id}/follow-ups`, { ...newMessageObject })
        .then(() => {
          this.thread.data.push(newMessageObject);
          this.newMessage = '';
          this.$nextTick(() => {
            const el = document.querySelector('.scrollable');
            el.scrollTop = el.scrollHeight;
          });
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
          if (this.errors.has('exception')) {
            toastr.error('An error occurred');
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style scoped>
.text-media {
  height: 15vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsMessages.vue